export * from './components/DocumentCard/index';
//# sourceMappingURL=DocumentCard.js.map